import React from 'react'
import {IoMdPin} from 'react-icons/io'
import Text from '@components/V3/Text'
import TextSkeleton from '@components/V3/Text/TextSkeleton'
import dropOffTypeLabels from '@helpers/labels/dropOffTypeLabels'
import isCompleted from '@page-components/TrackV2/helpers/isCompleted'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'
import useStatus from '@page-components/TrackV2/hooks/useStatus'

export const AddressSkeleton = () => (
  <div className="flex items-center space-x-2">
    <IoMdPin size={20} />
    <div className="flex-1">
      <TextSkeleton type="body" className="w-4/5" />
      <TextSkeleton type="caption" className="w-3/5" />
    </div>
  </div>
)

export default function Address() {
  const {order} = useOrder()
  const status = useStatus()

  if (order.deliveryType !== 'delivery') {
    return null
  }

  if (status === 'cancelled') {
    return null
  }

  return (
    <div className="flex items-center space-x-2">
      <IoMdPin size={20} />
      <div className="flex-1">
        <Text type="body">
          {order.address.address} {order.address.addressLine2}
        </Text>
        {isCompleted(status) ? null : (
          <Text type="caption">{dropOffTypeLabels[order.dropOffType]}</Text>
        )}
      </div>
    </div>
  )
}
